// Phase 3 live coding — [SYSTEM] messages to Alex (unit-tested).
//
// Interview 56: after a submit closed the editor, Alex told the candidate it was "already
// open" and never called open_code_editor again. Every message that closes the editor
// now says so explicitly.

export const EDITOR_CLOSED_NOTE =
  'The editor is now CLOSED. Call open_code_editor again before asking for more code.';

/** Message sent when the editor closes: reason = 'submitted' (Submit button) or 'expired' (timer). */
export function editorClosedMessage(reason, language, code) {
  const head = reason === 'expired'
    ? `[SYSTEM] Coding time has expired. Candidate's submitted code (${language}):`
    : `[SYSTEM] Candidate submitted code early (${language}):`;
  return `${head}\n\n${code}\n\n${EDITOR_CLOSED_NOTE} Proceed with your follow-up questions on this code.`;
}
